import React, { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { useCustomerAuth } from "@/contexts/CustomerAuthContext";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Handles the return trip from Emergent-managed Google Auth: exchanges the
// short-lived session_id (URL hash) for a persistent httpOnly session cookie.
export default function CustomerAuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { setAuthenticated } = useCustomerAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const match = (location.hash || "").match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;
    const target = window.location.pathname || "/";

    if (!sessionId) {
      navigate(target, { replace: true });
      return;
    }

    (async () => {
      try {
        const { data } = await axios.post(
          `${API}/auth/customer/session`,
          {},
          { headers: { "X-Session-ID": sessionId }, withCredentials: true }
        );
        setAuthenticated(data);
      } catch (err) {
        console.warn("Customer auth exchange failed:", err?.response?.status ?? err?.message);
      } finally {
        window.history.replaceState(null, "", target);
        navigate(target, { replace: true });
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#051630] text-white/50 text-sm tracking-[0.2em] uppercase">
      Anmeldung wird verarbeitet…
    </div>
  );
}
